import ModelsProvider from '@vimcar/shared-components/components/ModelsProvider'
// @ts-expect-error@2306
import { colorPrimary } from '@vimcar/shared-utils/styles/colors'
import { createBrowserHistory } from 'history'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import * as React from 'react'
import { renderRoutes } from 'react-router-config'
import { Router } from 'react-router-dom'

import mkModelsConfig from '../models'
import { Root } from '../routedComponents'
import RequestProvider from './RequestProvider'
import TransitionProvider from './TransitionProvider'

const modelsConfig = mkModelsConfig()
const history = createBrowserHistory()

const fontFamily = ['"Source Sans Pro"', 'sans-serif'].join(',')

const routes = [
  {
    component: Root,
    path: '*',
  },
]

const muiTheme = getMuiTheme({
  fontFamily,
  palette: {
    primary1Color: colorPrimary,
    primary2Color: colorPrimary,
    pickerHeaderColor: colorPrimary,
  },
  typography: { fontFamily },
})

const App = () => (
  // @ts-expect-error@2786
  <RequestProvider history={history}>
    <ModelsProvider models={modelsConfig}>
      {/* @ts-expect-error@2786 */}
      <TransitionProvider history={history}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <Router history={history}>{renderRoutes(routes)}</Router>
        </MuiThemeProvider>
      </TransitionProvider>
    </ModelsProvider>
  </RequestProvider>
)

export default App
